import { graphql } from "relay-runtime"
import { useBetterDocMutation } from "@/modules/admin/better-doc/hooks/useBetterDocMutation"
import { useCancelBetterDocRecommendationMutation as useCancelBetterDocRecommendationMutationType } from "@/modules/admin/better-doc/services/__generated__/useCancelBetterDocRecommendationMutation.graphql"

const mutation = graphql`
  mutation useCancelBetterDocRecommendationMutation($input: De_cancelBetterDocRecommendationInput!) {
    de_cancelBetterDocRecommendation(input: $input) {
      actionResult: de_BetterDocSessionActionResult {
        sessionId
        isSuccessful
        httpStatusCode
        betterDocState
        caseId
        errorReason
        exchangeId
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export const useCancelBetterDocRecommendationMutation = () => {
  return useBetterDocMutation<useCancelBetterDocRecommendationMutationType>(mutation)
}
